import React from "react";

// Renders NOTHING when there is no error.
//
// It used to return a full-height flex container with an empty div inside, so
// any code path that mounted it without an error painted a viewport-tall WHITE
// block. On the Trade tab that showed up as: skeleton → white screen → chart,
// because the chart's data gate fell through to here in the window between
// `loaders` going false and `data` being populated.
export function ChartError({ error }) {
    if (!error) return null;

    return (
        <div className="w-full flex justify-center flex-col items-center h-screen">
            <p className="text-red-500 text-lg font-semibold">Error: {error}</p>
        </div>
    );
}
